<template>
    <div class="standart_mem clr">
        
        <standart title="Відрядження" key="trip_addon"
                  v-bind:is_active_result=false
                  v-bind:is_active_problem=false
        >
            
            <template v-slot:mem_preamblua>
                <b-row class="doc_title" id="vac_text">
                    <b-col sm="3">
                        <label for="vac_text">текст відрядження *</label>
                    </b-col>
                    
                    <b-col sm="9">
                        <vue-editor
                            v-bind:placeholder=placeholder
                            :editor-toolbar="editor_rules"
                            id="trip_preamblua"
                            v-model="mem_preamblua">
                        </vue-editor>
                    </b-col>
                </b-row>
            </template>
            
        </standart>
        
        <legend>Маршрут</legend>
        
        <div class="trip_data">
            <div class="head row">
                <div class="field" :class="head.class" v-for="head in addon_fields">
                    <div class="title_min">{{head.name}}</div>
                </div>
                <div class="clr"></div>
            </div>
        </div>
        
        <b-container fluid>
            <div class="after_change">
                <div class="action_field row" v-for="(row,idx) in form.trip_fileds">
                    <div class="field_insert" :class="item.class" v-for="(item,idx2) in addon_fields">
                        <date-picker value-type="format"  v-if="item.insert_val === 'date_from'"
                                     v-model="form.trip_fileds[idx][idx2].value"
                                     :lang="d_lang" confirm
                                     :first-day-of-week="1">
                        
                        </date-picker>
                        
                        <div class="adv_selects">
                            <b-form-select
                                v-if="is_select(form.trip_fileds[idx][idx2])"
                                v-model="form.trip_fileds[idx][idx2].value"
                                :options="form.trip_fileds[idx][idx2].adv">
                            </b-form-select>
                            
                            <i
                                v-bind:id=get_uniq(idx,idx2)
                                v-if="can_add(form.trip_fileds[idx][idx2])"
                                @click="show_editor(idx,idx2)" class="fa fa-plus-square">
                            </i>
                            
                            
                            <b-popover :target=get_uniq(idx,idx2)
                                       triggers="click"
                                       :show.sync="form.trip_fileds[idx][idx2].show_popup"
                                       placement="auto"
                                       container="my-container"
                                       @show="onShow(form.trip_fileds[idx][idx2])"
                                       v-if="can_add(form.trip_fileds[idx][idx2])"
                            >
                                <template slot="title">
                                    <b-button @click="onClose(form.trip_fileds[idx][idx2])" class="close" aria-label="Close">
                                        <span class="d-inline-block" aria-hidden="true">&times;</span>
                                    </b-button>
                                    Додати пункт
                                </template>
                                <div>
                                    <b-form-group
                                        label="Текст"
                                        label-for="popover-input-1"
                                        label-cols="3"
                                        :state=popoverInputState(form.trip_fileds[idx][idx2])
                                        class="mb-1"
                                        description="Введіть пункт" invalid-feedback="Цей пункт є обовязковим">
                                        <b-form-input
                                            id="popover-input-1"
                                            v-model="form.trip_fileds[idx][idx2].popup_value"
                                            :state=popoverInputState(form.trip_fileds[idx][idx2])
                                            size="sm">
                                        </b-form-input>
                                    </b-form-group>
                                    
                                    <b-button @click="onOk(idx,idx2)" size="sm" variant="primary">Додати</b-button>
                                </div>
                            </b-popover>
                        </div>
                    </div>
                    
                    <div class="remove_row" @click="remove_row(idx)">
                        <i class="fa fa-trash-o active" aria-hidden="true"></i>
                    </div>
                    <div class="clr"></div>
                </div>
            </div>
        </b-container>
        
        <div class="control title_ mt-3">
            <button class="btn btn-outline-success " @click="add_row()">Додати</button>
        </div>
    </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import Standart from "../standart.vue";

import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});


export default {
    name: "trip",
    components: {
        Standart,
        DatePicker
    },
    data () {
        return {
            popoverShow: false,
            popeverTarget : '',
            popoverInput : '',
            form: {
                trip_fileds : []
            },
            ed_height : "150",
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
        }
    },
    
    mounted() {
        setTimeout(() => EventBus.$emit('remove_dir'), 500);
    },
    
    
    methods: {
        add_row: function () {
            let arr_push = JSON.parse(JSON.stringify(this.addon_fields));
            this.form.trip_fileds.push(arr_push);
            
        },
        get_uniq : function (idx,idx2) {
            return 'trip_add_field_' + idx + '_' + idx2;
        },
        
        
        is_select(row) {
            if(row.insert_val === 'trip_from' || row.insert_val === 'trip_to' || row.insert_val === 'car') {
                return true;
            }
        },
        
        can_add(row) {
            if(row.insert_val === 'trip_from' || row.insert_val === 'trip_to' ) {
                return true;
            }
        },
        
        remove_row : function (idx) {
            this.form.trip_fileds.splice(idx,1);
        },
        
        show_editor : function(idx,idx2) {
            
            try {
                let row = this.form.trip_fileds[idx][idx2];
                console.log('add_manual',row);
                row.show_popup = true;
                row.popup_value = '';
            }
            catch (e) {
                EventBus.$emit('show_toast', {err: e.message, type: "danger", title: e.name})
            }
        },
        
        //popover
        onOk(idx,idx2) {
            try {
                let row = this.form.trip_fileds[idx][idx2];
                if(row.popup_value.length > 0) {
                    let obj = {
                        text: row.popup_value,
                        value: row.popup_value
                    }
                    
                    row.adv.push(obj);
                    row.value = row.popup_value;
                    
                    
                    row.popup_value = '';
                    row.show_popup = false;
                }
                
            }
            catch (e) {
                EventBus.$emit('show_toast', {err:e.message ,type:"danger",title:e.name})
            }
            
            
        },
        onShow(row) {
            row.popup_value = '';
        },
        onClose(row) {
            row.popup_value = '';
            row.show_popup = false;
        },
        
        popoverInputState (row) {
            return row.popup_value.length > 0;
        },
    
    },
    
    computed: {
        
        ...mapFields([
            'active_memorandum'
        ]),
        
        can_format() {
            return true;
        },
        
        d_lang () {
            return this.get_datepickLang();
        },
        
        
        placeholder () {
            return 'Наприклад - Прошу погодити Іванову Івану Івановичу та водієві Петрову Петру Петровичу відрядження з 15.12.16 по 16.12.16 в м. Чернігів. \n' +
                'Мета - підведення підсумків аудиторської перевірки. \n' +
                'Проживання в готелі: з 15.12.16 на 16.12.16 – м. Чернігів  (1 ніч, 2 одномісних номера)';
        },
        
        active_mem () {
            return this.active_memorandum;
        },
        
        mem_title :  {
            get() {
                return this.active_mem.title;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{title : value});
            }
        },
        
        
        mem_preamblua : {
            get() {
                return this.active_mem.preamblua;
            },
            set (value) {
                this.$store.dispatch('memorandum_create/UPDATE_ACTIVE_MEM',{preamblua : value});
            }
        },
        
        addon_fields() {
            return this.active_memorandum.addon_data;
        },
        
        return_data : function () {
            return this.form;
        },
        
    },
    
}

</script>

<style scoped>
.quillWrapper .ql-editor {
    min-height: 150px !important;
}

legend {
    border-bottom: 1px solid #e5e5e5;
}
.control.title_ {
    margin-top: 20px;
}

.action_field {
    position: relative;
    margin-bottom: 13px;
}

.remove_row {
    color: red;
    position: absolute;
    top: 5px;
    right: -7px;
    font-size: 17px !important;
}

.after_change {
    margin-left: -15px;
}

.adv_selects {
    position: relative;
}

.adv_selects i {
    position: absolute;
    top: 6px;
    font-size: 25px;
    right: 30px;
    cursor: pointer;
}
</style>
